<template>
  <base-material-card
    icon="mdi-clipboard-text-outline"
    color="primary"
    inline
    v-if="inspectionProfile.equipmentProfile"
    class="mt-12 px-5 py-3"
  >
    <template v-slot:after-heading>
      <div class="title font-weight-bold overflow-ellipsis">
        {{ $t("inspectionProfile.details") }} -
        {{ inspectionProfile.equipmentProfile.equipTag }}
      </div>
    </template>

    <v-card-text v-if="inspectionProfile">
      <validation-observer v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(validateForm)">
          <v-card
            elevation="0"
            v-for="(grupo, index) in variables"
            :key="index"
          >
            <v-card-title>
              <v-chip
                color="primary"
                label=""
                :x-large="$vuetify.breakpoint.mdAndUp"
                >{{ $t(`groups.${grupo.name}`) }}</v-chip
              ></v-card-title
            >
            <v-row class="mx-auto" justify="space-around">
              <v-col
                cols="12"
                md="6"
                v-for="(variable, subindex) in grupo.variables"
                :key="subindex"
              >
                <validation-provider
                  v-if="variable.type === 'steps'"
                  rules="required"
                  :name="`${variable.code}`"
                >
                  <v-row class="mx-auto" justify="space-around">
                    <v-select
                      v-model="
                        inspectionProfile.data[index].variables[subindex].value
                      "
                      :items="variable.values"
                      label="Values"
                      item-text="name"
                      item-value="value"
                      outlined
                      dense
                      return-object
                    ></v-select>
                  </v-row>
                </validation-provider>
                <validation-provider
                  v-else-if="variable.type === 'flameColor'"
                  rules="required"
                  :name="`${variable.code}`"
                >
                  <v-row class="mx-auto" justify="space-around">
                    <v-select
                      v-model="colorSelected"
                      :items="[
                        { name: $t('flame.blue'), value: 3 },
                        { name: $t('flame.yellow'), value: 2 },
                        { name: $t('flame.orange'), value: 1 },
                        { name: $t('flame.red'), value: 0 }
                      ]"
                      label="Color"
                      item-text="name"
                      item-value="value"
                      outlined
                      dense
                    ></v-select>
                  </v-row>
                </validation-provider>
                <validation-provider
                  v-else-if="variable.type === 'flameStability'"
                  rules="required"
                  :name="`${variable.code}`"
                >
                  <v-row class="mx-auto" justify="space-around">
                    <v-select
                      v-model="stabilitySelected"
                      :items="[
                        { name: $t('flame.focused'), value: 2 },
                        { name: $t('flame.semiFocused'), value: 1 },
                        { name: $t('flame.highDispersion'), value: 0 }
                      ]"
                      item-text="name"
                      item-value="value"
                      label="Stability"
                      outlined
                      dense
                    ></v-select>
                  </v-row>
                </validation-provider>
                <validation-provider
                  v-else-if="variable.type === 'deathLine'"
                  rules="required"
                  :name="`${variable.code}`"
                >
                  <v-row class="mx-auto" justify="space-around">
                    <v-dialog
                      ref="dialog"
                      v-model="modal"
                      :return-value.sync="date"
                      persistent
                      width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="variable.value"
                          :label="
                            variablesTags.has(variable.code)
                              ? `${variablesTags.get(variable.code)} - ${$t(
                                  `variables.${variable.code}`
                                )}`
                              : $t(`variables.${variable.code}`)
                          "
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="date" scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="modal = false">
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="
                            modal = false;
                            variable.value = date;
                          "
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-row>
                </validation-provider>
                <validation-provider
                  v-else
                  v-slot="{ errors }"
                  rules="required"
                  :name="$t(`variables.${variable.code}`)"
                >
                  <v-text-field
                    v-if="
                      inspectionProfile &&
                        inspectionProfile.data &&
                        inspectionProfile.data.length > 0
                    "
                    v-model.number="
                      inspectionProfile.data[index].variables[subindex].value
                    "
                    :type="'number'"
                    step=".01"
                    :error-messages="errors"
                    color="gray"
                    :readonly="!adminAndUp"
                    :label="
                      variablesTags.has(variable.code)
                        ? `${variablesTags.get(variable.code)} - ${$t(
                            `variables.${variable.code}`
                          )}`
                        : $t(`variables.${variable.code}`)
                    "
                    :hint="unit(variable.type) | capitalize"
                    persistent-hint=""
                    validate-on-blur
                  />
                </validation-provider>
              </v-col>
            </v-row>
            <v-divider class="my-12"></v-divider>
          </v-card>
          <v-textarea
            v-model="inspectionProfile.details"
            row-height="4"
            label="Observaciones"
            filled
            :readonly="!$store.getters['auth/adminAndUp']"
            hint="Agrega comentarios y observaciones referentes a la inspeccion"
            persistent-hint
          ></v-textarea>
          <v-card-actions class="mt-12">
            <v-spacer></v-spacer
            ><v-btn
              width="250"
              :x-large="$vuetify.breakpoint.mdAndUp"
              primary
              :disabled="!adminAndUp"
              type="submit"
              rounded
              color="primary"
            >
              {{ $t("inspectionProfile.update") }}
            </v-btn>
            <v-spacer></v-spacer
          ></v-card-actions></form
      ></validation-observer>
    </v-card-text>
  </base-material-card>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { unitDefault, unitTypes } from "@/settings/unitTypes";
import readValues from "@/mixins/readValues";
import _ from "lodash";
import { db } from "@/plugins/db.js";
import writeValues from "@/mixins/writeValues";
export default {
  props: ["variablesTags"],
  computed: {
    ...mapState("inspections", ["inspectionProfile"]),
    ...mapState("auth", ["user"]),
    ...mapGetters("auth", ["isMetric", "isMetax", "adminAndUp"])
  },
  mixins: [readValues, writeValues],
  data: () => ({
    variables: [],
    colorSelected: 1,
    stabilitySelected: 1,
    date: new Date().toISOString().substr(0, 10),
    menu: false,
    modal: false
  }),
  methods: {
    setValues() {
      let dis = this;
      let data = _.chain(dis.inspectionProfile?.data)
        .map(d => d.variables)
        .flatten()
        .value();
      data.forEach(v => {
        v.value = [unitTypes.deathLine, "steps"].includes(v.type)
          ? v.value
          : dis.readValue(v).toFixed(2);
        // transforma la variable si no es metrico a metrico.
      });
      let result = _.chain(data)
        .groupBy("groups")
        .map((value, key) => ({ name: key, variables: value }))
        .value();
      return result;
    },
    saveValue(variable) {
      // transforma la variable si no es metrico a metrico.
      if (this.isMetric) {
        return parseFloat(variable?.value);
      } else {
        let unit = this.unit(variable?.type);
        return parseFloat(this.saveUnit(variable?.value, variable?.type, unit));
      }
    },
    readValue(variable) {
      if (this.isMetric) {
        return parseFloat(variable?.value);
      } else {
        let unit = this.unit(variable?.type);
        return parseFloat(
          this.transformUnit(variable?.value, variable?.type, unit)
        );
      }
    },
    timeAgo(time) {
      const timeObject = [
        ["year", 31536000],
        ["month", 2592000],
        ["day", 86400],
        ["minute", 60],
        ["second", 1]
      ];

      const lang = this.user.language ? this.user.language : "en";
      const rtf = new Intl.RelativeTimeFormat(lang);

      const seconds = time / 1000;
      let timeago;

      for (const [unit, value] of timeObject) {
        if (seconds > value || unit === "seconds") {
          timeago = -Math.floor(parseFloat(seconds / +value));
          return `${rtf.format(timeago, unit)}`;
        }
      }
    },
    getLabel(variable) {
      let group = variable.groups;
      let name = this.$t(`variables.${variable.code}`);
      return `[${group}] ${name}`;
    },

    unit(item) {
      // Selecciona el Unit por defecto segun el perfil del usuario
      return this.isMetric
        ? unitDefault[item].metric
        : unitDefault[item].imperial;
    },
    async validateForm() {
      const res = await this.$dialog.confirm({
        text: this.$t("dashboard.canYouConfirm"),
        title: this.$t("dashboard.checkFields")
      });
      if (res == true) {
        let dis = this;
        const loading = dis.$vs.loading({
          background: "#730D0B",
          color: "rgb(255, 255, 255)",
          opacity: 1,
          type: "square"
        });
        dis.inspectionProfile?.data?.forEach(grupo => {
          switch (grupo.name) {
            case "flame":
              grupo?.variables?.forEach(variable => {
                variable.value = variable.alarmZone = dis.redZone(variable);
                variable.warningZone = dis.yellowZone(variable);
                variable.smoothZone = dis.greenZone(variable);
              });
              break;
            case "steps":
              break;
            default:
              grupo?.variables?.forEach(variable => {
                if (variable.type === unitTypes.deathLine) {
                  variable.alarmZone = dis.redZone(variable);
                  variable.warningZone = dis.yellowZone(variable);
                  variable.smoothZone = dis.greenZone(variable);
                } else {
                  variable.value = dis.saveValue(variable);
                  variable.alarmZone = dis.redZone(variable);
                  variable.warningZone = dis.yellowZone(variable);
                  variable.smoothZone = dis.greenZone(variable);
                }
              });
              break;
          }
        });
        let equipId = dis.inspectionProfile.equipmentProfile.id;
        dis.inspectionProfile.equipmentProfile = db
          .collection("equipments")
          .doc(dis.inspectionProfile.equipmentProfile.id);
        dis.inspectionProfile.resume = dis.resumeInspection(
          dis.inspectionProfile.data
        );
        let payload = {
          db: "inspections",
          data: dis.inspectionProfile,
          doc: dis.inspectionProfile.id
        };
        let newPayload = {
          db: "equipments",
          data: { lastInspection: dis.inspectionProfile.resume },
          doc: equipId
        };
        try {
          await dis.$store.dispatch("updateDocument", payload);
          await dis.$store.dispatch("updateDocument", newPayload);
          await this.$store.dispatch(
            "inspections/bindAnInspection",
            this.$route.params.id
          );
          this.variables = this.setValues();
          dis.$dialog.notify.success("Inspection was updated successfully", {
            position: "top-right",
            timeout: 5000
          });
        } catch (error) {
          this.$dialog.notify.error(error, {
            position: "top-right",
            timeout: 5000
          });
        }
        loading.close();
      }
    },
    redZone(variable) {
      if (variable.type === unitTypes.deathLine) {
        let actualTime = new Date() - new Date(variable.value);
        if (actualTime > variable.values[3] * 1000) {
          return {
            status: true,
            code: variable.code,
            value: this.timeAgo(actualTime),
            unit: variable.unit,
            type: variable.type
          };
        } else {
          return { status: false, code: null };
        }
      } else if (variable.type === "steps") {
        return { status: false, code: null };
      }
      // Compara si esta en la banda roja de los rangos
      if (
        variable?.value > variable?.values[3] ||
        variable?.value < variable?.values[0]
      ) {
        return {
          status: true,
          code: variable.code,
          value: variable.value,
          unit: variable.unit,
          type: variable.type
        };
      } else {
        return {
          status: false,
          code: null,
          value: variable.value,
          unit: variable.unit,
          type: variable.type
        };
      }
    },
    greenZone(variable) {
      if (variable.type === unitTypes.deathLine) {
        let actualTime = new Date() - new Date(variable.value);
        if (actualTime <= variable.values[2] * 1000) {
          return {
            status: true,
            code: variable.code,
            value: this.timeAgo(actualTime),
            unit: variable.unit,
            type: variable.type
          };
        } else {
          return { status: false, code: null };
        }
      } else if (variable.type === "steps") {
        return { status: false, code: null };
      }
      // Compara si esta en la banda verde de los rangos
      if (
        variable?.values[1] <= variable?.value &&
        variable?.value <= variable?.values[2]
      ) {
        return {
          status: true,
          code: variable.code,
          value: variable.value,
          unit: variable.unit,
          type: variable.type
        };
      } else {
        return {
          status: false,
          code: null,
          value: variable.value,
          unit: variable.unit,
          type: variable.type
        };
      }
    },
    yellowZone(variable) {
      if (variable.type === unitTypes.deathLine) {
        let actualTime = new Date() - new Date(variable.value);
        if (
          actualTime <= variable.values[3] * 1000 &&
          actualTime > variable.values[2] * 1000
        ) {
          return {
            status: true,
            code: variable.code,
            value: this.timeAgo(actualTime),
            unit: variable.unit,
            type: variable.type
          };
        } else {
          return { status: false, code: null };
        }
      } else if (variable.type === "steps") {
        return { status: false, code: null };
      }
      // Compara si esta en la banda amarilla de los rangos
      if (
        (variable?.values[2] < variable?.value &&
          variable?.value <= variable?.values[3]) ||
        (variable?.values[0] <= variable?.value &&
          variable?.value < variable?.values[1])
      ) {
        return {
          status: true,
          code: variable.code,
          value: variable.value,
          unit: variable.unit,
          type: variable.type
        };
      } else {
        return {
          status: false,
          code: null,
          value: variable.value,
          unit: variable.unit,
          type: variable.type
        };
      }
    },
    resumeInspection(inspection) {
      let data = _.chain(inspection)
        .map(d => d.variables)
        .flatten()
        .value();

      let alarmZone = {
        count: _.chain(data)
          .filter({ alarmZone: { status: true } })
          .size()
          .value(),
        codes: _.chain(data)
          .filter({ alarmZone: { status: true } })
          .map(v => {
            let variable = {};
            variable.groups = v.groups;
            variable.code = v.code;
            variable.unit = v.unit;
            variable.value = v.value;
            variable.type = v.type;
            return variable;
          })
          .value()
      };
      let warningZone = {
        count: _.chain(data)
          .filter({ warningZone: { status: true } })
          .size()
          .value(),
        codes: _.chain(data)
          .filter({ warningZone: { status: true } })
          .map(v => {
            let variable = {};
            variable.groups = v.groups;
            variable.code = v.code;
            variable.unit = v.unit;
            variable.value = v.value;
            variable.type = v.type;
            return variable;
          })
          .value()
      };
      let smoothZone = {
        count: _.chain(data)
          .filter({ smoothZone: { status: true } })
          .size()
          .value(),
        codes: _.chain(data)
          .filter({ smoothZone: { status: true } })
          .map(v => {
            let variable = {};
            variable.groups = v.groups;
            variable.code = v.code;
            variable.unit = v.unit;
            variable.value = v.value;
            variable.type = v.type;
            return variable;
          })
          .value()
      };
      let resume = {
        alarmZone: alarmZone,
        smoothZone: smoothZone,
        warningZone: warningZone
      };

      if (alarmZone.count > 0) {
        resume.status = {
          name: this.$t("inspectionProfile.status.alarm"),
          color: "#B81D13",
          value: 3
        };
      } else if (warningZone.count > 0) {
        resume.status = {
          name: this.$t("inspectionProfile.status.warning"),
          color: "#EFB700",
          value: 2
        };
      } else {
        resume.status = {
          name: this.$t("inspectionProfile.status.smooth"),
          color: "#008450",
          value: 1
        };
      }

      return resume;
    }
  },
  created() {
    this.variables = this.setValues();
  }
};
</script>

<style></style>
